import { api } from '../lib/api'

export type PostCategory = {
  id: number
  name: string
  slug: string
  sort_order?: number
}

export async function listPostCategories(): Promise<PostCategory[]> {
  const { data } = await api.get<{ results: PostCategory[] }>('/api/posts/categories/')
  return Array.isArray((data as any)?.results) ? (data as any).results : []
}

